import { Cluster, ClusterStats, Renderer } from '@googlemaps/markerclusterer';
import { MapMarkerFactory } from './map-marker-factory';

export class MapMarkerRenderer implements Renderer {
  private count!: number;
  private position!: google.maps.LatLng;
  private markerFactory!: MapMarkerFactory;

  constructor(markerFactory: MapMarkerFactory) {
    this.markerFactory = markerFactory;
  }

  render(cluster: Cluster, stats: ClusterStats): google.maps.Marker {
    this.count = cluster.count;
    this.position = cluster.position;

    return this.markerFactory.create({
      position: {
        lat: this.position.lat(),
        lng: this.position.lng(),
      },
      count: this.count,
    });
  }
}
